export type EmergencySlotIcon = keyof typeof emergencySlotIconMapping

const PATH = "emergency-slot"

export const emergencySlotIconMapping = {
  return: `${PATH}/Return.svg`,
  box: `${PATH}/Box.svg`,
  umbrella: `${PATH}/Umbrella.svg`,
  car: `${PATH}/Car.svg`,
  timer: `${PATH}/Timer.svg`
}
